import React from 'react';
import clsx from 'clsx';
import { Flex, FlexProps } from '@common/components';

const GAP_SIZE_MAP = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 40,
};

export type GapSizeType = keyof typeof GAP_SIZE_MAP;

/**
 * The Gap component is just an extension of the Flex component adding the gap behavior beyond
 * the regular flex behavior. That's why it inherits all the props from the Flex component.
 */
export const Gap = ({
  className,
  children,
  size = 'sm',
  ...props
}: FlexProps & {
  size?: GapSizeType;
}) => {
  return (
    <>
      <Flex {...props} className={clsx('wk-gap', `wk-gap--${size}`, className)}>
        {children}
      </Flex>
      <style jsx global>{`
        .wk-gap--xs {
          gap: ${GAP_SIZE_MAP.xs}px;
        }
        .wk-gap--sm {
          gap: ${GAP_SIZE_MAP.sm}px;
        }
        .wk-gap--md {
          gap: ${GAP_SIZE_MAP.md}px;
        }
        .wk-gap--lg {
          gap: ${GAP_SIZE_MAP.lg}px;
        }
        .wk-gap--xl {
          gap: ${GAP_SIZE_MAP.xl}px;
        }
        .wk-gap--xxl {
          gap: ${GAP_SIZE_MAP.xxl}px;
        }
      `}</style>
    </>
  );
};
